<template>
  <v-dialog v-model="isOpen" persistent max-width="500">
    <v-card class="pa-6">
      <p class="mt-3 mb-8 text-center">
        {{ $t("message.companyProfile.monitoredKeywords.deleteDialogLabel") }}
      </p>

      <div class="d-flex flex-column flex-sm-row flex-wrap justify-center">
        <ui-button
          color="primary"
          outlined
          class="mb-2 mx-1 min-w-130"
          @click="cancelDeletingKeyword"
        >
          {{ $t("message.common.cancel") }}
        </ui-button>
        <ui-button
          color="primary"
          @click="deleteKeyword"
          class="mb-2 mx-1 min-w-130"
        >
          {{ $t("message.common.delete") }}
        </ui-button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteKeywordDialog",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    cancelDeletingKeyword() {
      this.$emit("cancel");
    },
    deleteKeyword() {
      this.$emit("delete");
    }
  }
};
</script>

<style lang="scss" scoped>
.min-w-130 {
  min-width: 130px !important;
}
</style>
